import { Comment } from '@nemuru-eng/js-api-client';

export const getCommentChannelIcon = (channel: Comment['channel']) => {
  switch (channel) {
    case 'api':
      return 'dns';
    case 'voice':
      return 'call';
    case 'web':
      return 'desktop_windows';
    case 'system':
      return 'keyboard';
    case 'email':
      return 'email';
    default:
      return 'desktop_windows';
  }
};
